<template>
    <div>
        <el-row type="flex"  justify="center">
            <el-col :span="24" class='member_out'>
                <p class='title'>登录“江苏省音乐家协会”</p>
                <el-form  class="ruleForm" :model="formData" ref="formData" :rules="rules2">
                    <div>
                        <div class='formCon '>
                            <el-form-item prop="account" class='form_cc'>
                                <div class='form_icon'>
                                    <i class='icon iconuser'></i> 
                                </div>
                                <el-input v-model="formData.account" class='inpStyle' placeholder="填写您的登录账号"></el-input>
                            </el-form-item>
                            <el-form-item prop="password" class='form_cc'>
                                <div class='form_icon'>
                                    <i class='icon iconpass'></i> 
                                </div>
                                <el-input type="password" v-model="formData.password" class='inpStyle' placeholder="填写您的登录密码"></el-input>
                            </el-form-item>
                        </div>   
                        <div class='form_login'>
                            <el-form-item>
                                <button class='loginBtn' @click.prevent="login('formData') ">登录</button>
                            </el-form-item>
                        </div>
                        <div class='login_password'>
                            <a class='cor' @click='()=>{this.$router.push({name:"userForget"})}'>忘记密码了?</a>
                            <a class='cor' style="vertical-align:middle;" @click='()=>{this.$router.push({name:"indexRegister"})}' >立即注册&nbsp;<i class='icon iconarrow'></i></a>
                        </div>     
                    </div>     
                </el-form> 
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        let account = (rule, value, callback) => {
        if (value=='') {
           callback(new Error('登陆账号不能为空'));
        }else{
            callback();
        }
      };
        let password = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入密码'));
        } else {
        //   if (this.ruleForm2.checkPass !== '') {
        //     this.$refs.ruleForm2.validateField('checkPass');
        //   }
          callback();
        }
      };
        return {
            formData: {
                account: '',
                password:''
            },
            rules2: {
                account: [
                    {required: true, message: '登录账号不能为空', trigger: 'blur'}
                ],
                password: [
                    {required: true, message: '密码不能为空', trigger: 'blur'},
                ]
            },
        }
    },
    methods:{
        login(formData){
            // localStorage.removeItem('token')
            this.$refs[formData].validate((valid) => {
                console.log(11111111)
                if (valid) {
                    let self = this;
                    window.Global.post('/user/login',{
                        username:self.formData.account,
                        // password:self.formData.password
                        password:self.$md5(self.formData.password)
                    },rs => {
                        console.log(222222222,rs)
                        if(rs.data.status==200){
                            sessionStorage.setItem('username',self.formData.account)
                            // window.Global.setLocalStorage('username',self.formData.account)
                            // window.Global.setLocalStorage('password',self.formData.password)
                            self.$message.success('登录成功')
                            window.Global.setLocalStorage('token',rs.data.result.token)
                            console.log(rs.data.result.token)
                            self.$router.push({name:"indexTutorial"})
                        }else{
                            self.$message.error("账号与密码不正确");
                        }
                    })
                    
                } else {
                    return false;
                }
            });
            console.log(this.formData)
        }
    }
}
</script>
<style lang="less">
@import '../../static/less/login.less';
</style>


   


// WEBPACK FOOTER //
// src/components/Login.vue